module.exports = __webpack_public_path__ + "static/author-3-4021d4b6a43b4e0ae9a4167cf4ed29de.jpg";